"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoized = exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _camelCase = _interopRequireDefault(require("../../utils/camelCase"));
var _memoize = _interopRequireDefault(require("../memoize"));
/**
 * @deprecated Please use the version found in the `library/` folder instead.
 *
 * Runs the current selections through the rules engine. `productId` is the
 * **site-level** product ID.
 *
 * Example Usage:
 * ```js
 * const request = {
 *  siteId: 1,
 *  productId: 2,
 *  selections: getSelections(choices, options),
 *  executeRuleSet: 'immediate',
 * };
 * ```
 *
 * @export
 * @param {*} executeRulesApi
 * @param {*} request ```{
 *   siteId: Int,
 *   productId (site-level): Int,
 *   selections: Selection[],
 *   executeRuleSet ("immediate", "all"): String (default: "all"),
 * }```
 * @returns
 */
function executeRules(eleanorBaseUrl, _ref) {
  var siteId = _ref.siteId,
    productId = _ref.productId,
    selections = _ref.selections,
    _ref$executeRuleSet = _ref.executeRuleSet,
    executeRuleSet = _ref$executeRuleSet === void 0 ? 'all' : _ref$executeRuleSet;
  var url = "".concat(eleanorBaseUrl, "/catalog/productconfiguration/executerulesviapost");
  var options = {
    data: {
      siteId: siteId,
      productId: productId,
      currentSelections: selections,
      executeRuleSet: executeRuleSet
    },
    url: url,
    method: 'POST',
    crossDomain: true,
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return (0, _axios["default"])(options).then(function (response) {
    return (0, _camelCase["default"])(response.data);
  });
}
var _default = exports["default"] = executeRules;
var memoized = exports.memoized = (0, _memoize["default"])(executeRules);
//# sourceMappingURL=executeRules.js.map